import Moment from 'moment';

function dateInPastValidator({ input, msgs }) {
  const FORMAT = 'MM/DD/YYYY';
  const today = new Moment();
  const isValidFormat = Moment(input, FORMAT).format(FORMAT) === input;

  if (!isValidFormat) {
    if (msgs && msgs.dateFormat) {
      return msgs.dateFormat;
    }
    return 'Please enter valid date using MM/DD/YYYY format';
  }

  if (
    !Moment(input, FORMAT).isBefore(today, 'day') &&
    !Moment(input, FORMAT).isSame(today, 'day')
  ) {
    if (msgs && msgs.pastdate) {
      return msgs.pastdate;
    }
    return 'Date must be in the past';
  }
  const pastDate = Moment().add(-100, 'year').format(FORMAT);

  if (!Moment(input, FORMAT).isAfter(pastDate, 'day')) {
    if (msgs && msgs.pastDateOutOfRange) {
      return msgs.pastDateOutOfRange;
    }
    return 'This date must fall within the last 100 years';
  }

  return null;
}

export default dateInPastValidator;
